require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-centrar-el-liderazgo-indigena-en-el-programa-amazo.json") })
        }
      }, "path---es-mx-update-centrar-el-liderazgo-indigena-en-el-programa-amazo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-centrar-el-liderazgo-indigena-en-el-programa-amazo!./.cache/json/es-mx-update-centrar-el-liderazgo-indigena-en-el-programa-amazo.json
// module id = 919
// module chunks = 231608221292675